<template>
  <div id="wrapper">
    <component
      :is="welcomeComponent"
      v-if="!isLoading"
      :pathfinders="devicePathfinders"
    ></component>
    <b-loading :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
  import PreviousDevice from "@/components/Welcome/PreviousDevice.vue";
  import NewDevice from "@/components/Welcome/NewDevice.vue";
  import { mapActions, mapState } from "vuex";

  export default {
    components: { NewDevice, PreviousDevice },
    data() {
      return {
        devicePathfinders: null
      };
    },
    computed: {
      welcomeComponent() {
        if (this.devicePathfinders) {
          return this.devicePathfinders.length > 0 ? PreviousDevice : NewDevice;
        } else {
          return "";
        }
      },
      isLoading() {
        return this.devicePathfinders === null;
      }
    },
    methods: {
      ...mapActions(["loadDevicePathfinders"])
    },
    created() {
      this.loadDevicePathfinders().then(pathfinders => {
        this.devicePathfinders = pathfinders;
      });
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";
  #wrapper {
    @include jungle-background;
    position: relative;
    height: 100%;
  }
</style>
